import Vue from "vue";

export async function fetchSurveys({ commit }) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/surveys/user_surveys`,
      params: {view_as: localStorage.getItem("view_as")}
    });
    
    commit("surveys/setSurveys", data, {
      root: true
    });
  } catch (e) {
    commit("surveys/surveysError", e.message, {
      root: true
    });
  } finally {
    // console.log("La petición para obtener las encuestas ha finalizado");
  }
}

export async function fetchSurvey({ commit }, slug) {
  let view_as = localStorage.getItem("view_as") || null
  try {
    const { data } = await Vue.axios({
      url: `/frontend/surveys/survey?slug=${slug}&view_as=${view_as}`
    });
    commit("setSurvey", data);
  } catch (e) {
    commit("surveyError", e.message);
  } finally {
    // console.log("La petición para obtener la encuesta ha finalizado");
  }
}

export async function addAnswer({ commit }, data) {
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/answers",
      data,
      params: {view_as: localStorage.getItem("view_as")}
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para crear el surveyo ha finalizado");
  }
}

export async function saveCreate({ commit }, data) {
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/answers",
      params: data
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para crear el survey ha finalizado");
  }
}

export async function saveAnswer({ commit }, answer) {
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/answers_options_save_from_vue",
      data: {
        option_id: answer.option,
        question_id: answer.question,
        user_id: answer.user
      }
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para crear el survey ha finalizado");
  }
}

export async function saveAnswerMultiple({ commit }, answer) {
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/answers_options_multiple_save_from_vue",
      data: {
        option_id: answer.option,
        question_id: answer.question,
        user_id: answer.user
      }
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para crear el survey ha finalizado");
  }
}

export async function saveField({ commit }, answer) {
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/answers_save_from_vue",
      data: {
        question_id: answer.question,
        answer_variable: answer.text,
        user_id: answer.user
      }
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para crear el survey ha finalizado");
  }
}

export async function removeAnswer({ commit }, option) {
  try {
    await Vue.axios({
      method: "DELETE",
      url: `/frontend/answers/${option.id}`
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para eliminar el surveyo ha finalizado");
  }
}

export async function updateSurvey({ commit }, survey) {
  try {
    await Vue.axios({
      method: "PUT",
      url: `/frontend/surveys/${survey.id}`,
      data: {
        id: survey.id,
        child_name: survey.child_name,
        child_lastname: survey.child_lastname,
        gender: survey.gender,
        surveyday: survey.surveyday,
        full_name_mother: survey.full_name_mother,
        full_name_father: survey.full_name_father,
        approved: true
      }
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para actualizar el surveyo ha finalizado");
  }
}

export async function removeSurvey({ commit, dispatch }, id) {
  try {
    await Vue.axios({
      method: "DELETE",
      url: `/frontend/surveys/${id}`
    });
    dispatch("fetchSurveys");
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para eliminar el survey ha finalizado");
  }
}

export async function checkData({ commit }, survey) {
  let survey_id = survey["survey_id"];
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/check_data",
      data: {
        survey_id: survey_id
      }
    });
  } catch (e) {
    commit("surveysError", e.message);
  } finally {
    // console.log("La petición para verificar datos ha finalizado");
  }
}
